/**
 * Extract the dynamic {{1}} segment from a website button URL sample.
 * e.g. template https://shop.com/t/{{1}} + example https://shop.com/t/abc → "abc"
 */
export function extractUrlButtonDynamicPart(urlTemplate, fullExample) {
  const t = (urlTemplate || "").trim();
  const ex = (fullExample || "").trim();
  if (!t || !ex) return ex || "";
  const marker = "{{1}}";
  const pos = t.indexOf(marker);
  if (pos === -1) return ex;
  const prefix = t.slice(0, pos);
  const suffix = t.slice(pos + marker.length);
  if (ex.startsWith(prefix) && ex.endsWith(suffix)) {
    return ex.slice(prefix.length, ex.length - suffix.length);
  }
  return ex;
}

/** Button index keys for website CTAs that use {{1}} in the URL. */
export function getDynamicWebsiteButtonSlots(template, variableSamples = {}) {
  const stored = variableSamples?.buttons || {};
  const ctaButtons = template?.attrs?.ctaButtons || [];
  const slots = {};

  ctaButtons.forEach((btn, idx) => {
    const type = String(btn?.type || "").toLowerCase();
    const url = typeof btn?.value === "string" ? btn.value : "";
    if (type !== "website" || !/\{\{1\}\}/.test(url)) return;

    const key = String(idx);
    const storedVal = stored[key] ?? stored[idx];
    slots[key] = storedVal != null
      ? String(storedVal)
      : extractUrlButtonDynamicPart(url, btn.urlExample || "");
  });

  return slots;
}

export function buildButtonVariableSamplesFromCta(ctaButtons = []) {
  const buttons = {};
  ctaButtons.forEach((btn, idx) => {
    const type = String(btn?.type || "").toLowerCase();
    const url = typeof btn?.value === "string" ? btn.value.trim() : "";
    if (type !== "website" || !/\{\{1\}\}/.test(url)) return;
    buttons[String(idx)] = extractUrlButtonDynamicPart(url, btn.urlExample || "");
  });
  return buttons;
}

/** Empty user-fillable values for each template variable slot. */
export function emptyTemplateVariablesFromSamples(samples) {
  const fill = (slot) => Object.fromEntries(Object.keys(slot || {}).map((k) => [k, ""]));
  return {
    header: fill(samples?.header),
    body: fill(samples?.body),
    footer: fill(samples?.footer),
    buttons: fill(samples?.buttons),
  };
}

/** Merge stored variable_sample with dynamic website button slots from ctaButtons. */
export function getEffectiveTemplateVariableSamples(template) {
  let variableSamples = { header: {}, body: {}, footer: {}, buttons: {} };
  const raw = template?.attrs?.variableSamples;
  if (raw) {
    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      variableSamples = { ...variableSamples, ...parsed };
    } catch (e) {
      /* ignore */
    }
  }
  return {
    header: variableSamples.header || {},
    body: variableSamples.body || {},
    footer: variableSamples.footer || {},
    buttons: getDynamicWebsiteButtonSlots(template, variableSamples),
  };
}
